import React, { useState } from "react";
import Logo from "../assets/LOGO.png";
import InformationPopup from "./informationModal/LogoutModal";
const Header = ({ loadWeb3, account }) => {
  const [logout, setLogout] = useState(false);

  const connectHandler = () => {
    if (account) {
      // window.localStorage.removeItem("account");
      // window.location.reload();

      setLogout(true);
    }
    if (!account) {
      loadWeb3();
    }
  };

  const logoutHandler = async () => {
    // await window.web3.eth.currentProvider.disconnect();
    window.localStorage.removeItem("account");
    window.location.reload();
  };
  return (
    <div className=" ">
      <div className="container grid grid-flow-col  gap-x-10 justify-center items-center">
        {/* <div></div> */}
        <a
          href="https://chadnft.online/"
         target={"_blank"} rel="noreferrer"
          
          className="w-28 sm:w-60 py-2"
         
        >
          <img src={Logo} className="" alt="" />
        </a>
        <div>
          <button
            className="bg-primary-400 py-1.5 px-4 rounded-sm  text-white uppercase"
            onClick={connectHandler}
          >
            {account
              ? `${account.slice(0, 5)}...${account.slice(account.length - 5)}`
              : "Connect Wallet"}
          </button>
        </div>
      </div>
      <InformationPopup
        open={logout}
        onClose={setLogout}
        title="Logout"
        text="Do you want Logout?"
        handler={logoutHandler}
      />
    </div>
  );
};

export default Header;

